import React, { useMemo } from 'react'
import View from './view.js'
import { useDataValue } from 'Simple/Data.js'
import { twoDigitsTime } from 'Data/format.js'

export default function Logic(props) {
  let slot_min_time = useDataValue({
    context: 'timegrid',
    path: 'slot_min_time',
    viewPath: props.viewPath,
  })

  let [, startMinutes] = slot_min_time.split(':').map(_ => parseInt(_, 10))
  let [timePart, range] = props.time.split(/(am|pm)/).filter(Boolean)
  let [hours, minutes] = timePart.split(':').map(_ => parseInt(_, 10))
  if (!minutes) minutes = 0

  let showHourLabel = useMemo(
    () => startMinutes === minutes,
    [startMinutes, minutes]
  )

  return (
    <View
      {...props}
      hours={showHourLabel && hours}
      minutes={twoDigitsTime(minutes)}
      range={showHourLabel && range.toUpperCase()}
    />
  )
}
